<template>
  <div class="category">
    <div class="category__container">
      <h2 class="category__h2">{{thisCategoryObj.chinese}}</h2>
      <div class="category__body">
        <product-list
        :list='filteredProducts'
        :category='thisCategoryObj'></product-list>
      </div>
    </div>
  </div>
</template>

<script>
import productList from '@/components/ProductList.vue';

export default {
  components: { productList },
  computed: {
    filteredProducts() {
      let products;
      this.$bus.$on('son_get_data', (data) => {
        products = data.products;
      });
      this.$bus.$emit('son_call_data');
      if (this.$route.params.category !== 'all') {
        products = products
          .filter((item) => item.category
            .find((item2) => item2.english === this.$route.params.category) !== undefined);
      }
      return products;
    },
    categoryObjs() {
      let arr;
      this.$bus.$on('son_get_data', (data) => {
        arr = data.products;
      });
      this.$bus.$emit('son_call_data');
      arr = arr.map((item) => item.category).flat(2)
        .map((item) => JSON.stringify(item));
      arr = [...new Set(arr)]
        .sort()
        .map((item) => JSON.parse(item));
      return arr;
    },
    thisCategoryObj() {
      let thisCategoryObj;
      if (this.$route.params.category === 'all') {
        thisCategoryObj = {
          chinese: '全部',
          english: 'all',
        };
      } else {
        thisCategoryObj = this.categoryObjs
          .find((item) => item.english === this.$route.params.category);
      }
      return thisCategoryObj;
    },
  },
  methods: {
    go_page(route) {
      this.$router.push(route);
    },
  },
};
</script>
